/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import t from "prop-types";
import { EnumFilter as s } from "./EnumFilter.mjs";
import { filterIsTrue as i, filterIsFalse as p } from "../../messages/index.mjs";
const e = class e extends r.Component {
  constructor() {
    super(...arguments), this.data = [
      { text: i, value: !0 },
      { text: p, value: !1 }
    ];
  }
  /**
   * @hidden
   */
  render() {
    return /* @__PURE__ */ r.createElement(
      s,
      {
        filter: this.props.filter,
        onFilterChange: this.props.onFilterChange,
        data: this.props.data || this.data,
        defaultItem: this.props.defaultItem,
        ariaLabel: this.props.ariaLabel
      }
    );
  }
};
e.propTypes = {
  filter: t.object.isRequired,
  onFilterChange: t.func.isRequired,
  data: t.arrayOf(t.shape({ text: t.string, value: t.any })),
  ariaLabel: t.string,
  defaultItem: t.any
};
let a = e;
export {
  a as BooleanFilter
};
